import { Route, Routes, BrowserRouter } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import AppErrorBoundary from "./components/AppErrorBoundary";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import SandboxPage from "./pages/SandboxPage";
// import ForgotPasswordPage from "./pages/ForgotPasswordPage";
// import ResetPasswordPage from "./pages/ResetPasswordPage";
// import VerifyEmailPage from "./pages/VerifyEmailPage";
// import ConfirmEmailPage from "./pages/ConfirmEmailPage";

export default function App() {
  return (
    // h-full/w-full against the locked html/body chain rather than 100vh/100vw,
    // which can exceed the visible area once a scrollbar is present.
    <div className="h-full w-full flex flex-col bg-neutral-900 overflow-hidden">
      <AppErrorBoundary>
        <BrowserRouter>
          <Routes>
            {/* --- Public Routes --- */}
            <Route path="/callback" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/sandbox" element={<SandboxPage />} />
            {/* <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/confirm-email" element={<ConfirmEmailPage />} /> */}

            {/* --- Protected Routes --- */}
            {/* The "/*" path catches all other routes and sends them through the ProtectedRoute gatekeeper. */}
            <Route path="/*" element={<ProtectedRoute />} />
          </Routes>
        </BrowserRouter>
      </AppErrorBoundary>
    </div>
  );
}
